var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-page-title',[_c('h1',[_vm._v("Ajuda")])]),_c('v-container',[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"w-100 text-center"},[_vm._v(" Se sentir dificuldades ou necessitar de algum esclarecimento, contacte-nos por email. ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }